import React, { useCallback, useRef } from 'react';
import { AdvancedMarker, InfoWindow } from '@vis.gl/react-google-maps';
import MarkerPin from './marker_pin';
import MarkerPinSelected from './marker_pin_selected';
import { useDispatch } from 'react-redux';
import { selectDevice } from '../../redux/mapStateSlice';
import DeviceCard from './marker_device_card';
import { useSelector } from 'react-redux';
import MapPin from './marker_pin_custom';
import { getStatusColor } from '../../utils/status_color';

const DeviceMarker = React.memo(({ device, setMarkerRef, isInspected, isSelected}) => {
  const dispatch = useDispatch();
  const markerRef = useRef(null);

  const handlePinClick = useCallback(() => {
    if (isInspected) return;
    dispatch(selectDevice(device.sensor_id));
  }, [isInspected, dispatch]);

  const districts = useSelector(state => state.districts.districts);
  const getDistrictName = (districtId) => {
    const district = districts.find(d => d.id === districtId);
    return district ? district.name : 'Unknown District';
  };

  const ref = useCallback(
    (marker) =>
      {
        markerRef.current = marker;
        setMarkerRef(marker, device.sensor_id);
      },
    [setMarkerRef, device.sensor_id]
  );

  const createCustomContent = (status) => {
    const div = document.createElement('div');
    div.className = 'custom-marker-content';
    div.setAttribute('data-status', status);
    div.innerHTML = `
      <div class="marker-content">
        <span>Status: ${status}</span>
      </div>
    `;
    return div;
  };

  return (
      <AdvancedMarker
        onClick={handlePinClick}
        key={device.sensor_id}
        position={{ lat: device.lat, lng: device.lng }}
        ref={ref}
        content={createCustomContent(device.status)}
      >
        <div className="data-status-container" data-status={device.status}>
          <MapPin 
            pinColor={"#051A36"} 
            glyphColor={getStatusColor(device.status)} 
            borderColor={isInspected ? getStatusColor(device.status) : "#051A36"} 
          />
        </div>
        {isSelected && !isInspected &&
          <InfoWindow 
            anchor={markerRef.current}
            headerContent={<div className="text-lg font-semibold -mt-1">{getDistrictName(device.district)} #{device.location}</div>}
            onCloseClick={() => {
              dispatch(selectDevice(null));
            }}
          >
            <DeviceCard device={device} />
          </InfoWindow>
        }
      </AdvancedMarker>
  );
});

export default DeviceMarker;
